<template>
    <Popup
      v-if="isVisible"
      name="temporary"
      :extra-classes="['temporary-popup', 'popup--less-spacing']"
      context="global"
      position="center-top"
      :showDelay="0"
    >
    <template v-slot:content>
      <slot></slot>
    </template>
    </Popup>
  </template>

<script setup>
  import Popup from '@/components/popups/Popup.vue'
  import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
  const { hide, show, isVisible } = useSpecificPopup('temporary')
  import { computed } from 'vue'

  const props = defineProps({
    show: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 2000
    }
  })

  const showTemporarily = () => {
    show()
    setTimeout(hide, props.duration)
  }

  defineExpose({
    showTemporarily,
  })
</script>

 <style scoped>
   .temporary-popup {
      top: 5%;
      position: fixed;
      width: auto;
   }
</style>
